import { EditingViewState, CpsGridView, UpdateViewRequest } from '@cs-cms/types';
import { createContext, useContext } from 'react';

interface IViewsContext {
  views: CpsGridView[] | undefined;
  selectedView: number | undefined;
  setSelectedView?: (view: number | undefined) => void;
  selectedViewData: CpsGridView | undefined;
  mutateViewLoading: boolean;
  onUpdateView?: (data: UpdateViewRequest) => void;
  hasUnsavedChanges?: boolean;
  setHasUnsavedChanges?: (hasChanges: boolean) => void;
  editingViewState: EditingViewState;
  setEditingViewState?: (state: EditingViewState) => void;
}

export const initEditingViewState: EditingViewState = {
  fields: [],
  activeField: undefined,
  globalFilters: []
};

export const ViewsContext = createContext<IViewsContext>({
  views: undefined,
  selectedView: undefined,
  selectedViewData: undefined,
  mutateViewLoading: false,
  editingViewState: initEditingViewState
});

export const useViewsContext = () => useContext(ViewsContext);
